import { Col, Container, Row } from 'react-bootstrap';
import { Phone, Mail } from 'feather-icons-react';

const contactDetails = [
  {
    icon: <Phone size="20" color="#fff" />,
    heading: 'To More Inquiry',
    value: '+91-96 2783 2783'
  },
  {
    icon: <Mail size="20" color="#fff" />,
    heading: 'To Send Mail',
    value: 'info@crud-operations.com'
  }
];

function Map() {
  return (
    <Container fluid>
      <Row className="mapBg">
        <Col
          lg={3}
          md={3}
          sm={5}
          xs={8}
          className="mapBg_message m-lg-10 m-md-8 m-2 text-white p-lg-5 p-md-4 p-3"
        >
          <p className="m-0 fs-lg-8 fs-md-8 fs-9">145 GST Road</p>
          <p className="fs-lg-8 fs-md-8 fs-9">Urapakkam, Chennai - 603210</p>
          <div className="mt-2 d-flex flex-column gap-2">
            {contactDetails.map((info, idx) => (
              <div key={idx} className="d-flex gap-3 align-items-center">
                <div>{info?.icon}</div>
                <div>
                  <div className="text-white fw-bold fs-9">{info?.heading}</div>
                  <div className="fs-8">{info?.value}</div>
                </div>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Map;
